import GenericDialog from "./generic";
import { t } from "i18next";
import LabeledField from "providers/labeledField";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { account } from "store/account/accountSelectors";
import { formatDate } from "util/datelib";
import GenericButton from "widgets/controls/buttons/generic";

const formatValue = (key: any, value: string | number | Date) => {
  switch (key) {
    case "created":
    case "lastcomms":
      return formatDate(new Date(value), "lastcomms"); // Format the date and convert it to a string

    default:
      return String(value);
  }
};

const GlobalSearchDialog = ({
  isOpen,
  onClose,
  result,
}: {
  isOpen: boolean;
  onClose: () => void;
  result: Record<string, string>;
}) => {
  const navigate = useNavigate();
  const keys = Object.keys(result);
  const accountContext = useSelector(account, shallowEqual);

  const routeDevTools = () => {
    onClose();
    navigate(`/admin/devices/devtools?snr=${result?.snr}`);
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      title={t("global.result.title")}
      size="xs"
    >
      <div className="flex flex-col gap-2">
        <div className="grid grid-cols-1 gap-1 md:gap-2">
          {keys.map((item: string, index) => (
            <LabeledField
              label={`${t("global.result.item", { context: item })}: `}
              id={`result-${item}`}
              key={index}
              className="heading-sm"
              textColor="secondary"
            >
              <label
                className={`text-secondary whitespace-normal break-words text-txt-md`}
              >
                {formatValue(item, result[item])}
              </label>
            </LabeledField>
          ))}
        </div>
        {result["account"] === accountContext.name && (
          <div className="flex justify-end mt-4">
            <GenericButton text={t("button.action.devtools") as string} onClick={routeDevTools} size="md" />
          </div>
        )}
      </div>
    </GenericDialog>
  );
};

export default GlobalSearchDialog;
